//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QfMProcessConfigure from "./qf-m-process-configure.vue";

export default {
    name: "QfPProcessConfigure",
    components: { QfMProcessConfigure },
    props: ["mapping"],
    data() {
        return {
            showModal: false,
            currentEdit: null,
            removing: false
        };
    },
    methods: {
        configureProcess() {
            this.showModal = true;
        },
        onUpdate(mapping) {
            this.$emit("catchMappedData", mapping);
        },
        deleteConfig() {
            this.$emit("catchMappedData", {});
        }
    }
};
